export default __webpack_public_path__ + "static/HydroPhonics-cropped-319c211dc58bf1dda522109142eca180.png";